import { PageProps } from '@/types';
import { Reel } from '@/types/reel.type';
import { SelectOption } from '@/Components/Select';
import {
    DATE_RANGE_QUERY_PARAM,
    PerformanceQueryParam,
} from '@/types/performance.type';

//
// NOTE: CONSIDER USING TYPES FROM "@/types/flow.type" INSTEAD
//

//
// TODO: REVIEW & REMOVE DUPLICATED TYPES
//

export type SelectItem = {
    id: Omit<PerformanceQueryParam, typeof DATE_RANGE_QUERY_PARAM>;
    options: SelectOption[];
};

export type CustomSelectItem = {
    id: typeof DATE_RANGE_QUERY_PARAM;
    Component: React.FC<any>;
};

export const DEFAULT_SELECT_VALUE = 'all';

export const PERFORMANCE_TABLE_COLUMN_FLOW = 'performance/flow';
export const PERFORMANCE_TABLE_COLUMN_STATUS = 'performance/status';
export const PERFORMANCE_TABLE_COLUMN_TYPE = 'performance/type';
export const PERFORMANCE_TABLE_COLUMN_OBJECTIVE = 'performance/objective';
export const PERFORMANCE_TABLE_COLUMN_VISITORS_REACHED =
    'performance/visitors-reached';
export const PERFORMANCE_TABLE_COLUMN_VIDEO_REELS_PLAYED =
    'performance/video-reels-played';
export const PERFORMANCE_TABLE_COLUMN_CLICKS = 'performance/clicks';
export const PERFORMANCE_TABLE_COLUMN_ACTIVATION_URL =
    'performance/activation-url';
export const PERFORMANCE_TABLE_COLUMN_PUBLISHED_AT = 'performance/published-at';
export const PERFORMANCE_TABLE_COLUMN_IMPRESSIONS = 'performance/impressions';
export const PERFORMANCE_TABLE_COLUMN_STARTED = 'performance/started';
export const PERFORMANCE_TABLE_COLUMN_START_RATE = 'performance/start-rate';
export const PERFORMANCE_TABLE_COLUMN_VISITOR_INTERACTION_RATE =
    'performance/visitor-interaction-rate';
export const PERFORMANCE_TABLE_COLUMN_BUTTON_CLICKS =
    'performance/button-clicks';
export const PERFORMANCE_TABLE_COLUMN_BUTTON_ENGAGEMENT =
    'performance/button-engagement';
export const PERFORMANCE_TABLE_COLUMN_CONVERSIONS = 'performance/conversions';
export const PERFORMANCE_TABLE_COLUMN_TOTAL_WATCH_TIME_SECONDS =
    'performance/total-watch-time-seconds';

export const columnIds = [
    PERFORMANCE_TABLE_COLUMN_FLOW,
    PERFORMANCE_TABLE_COLUMN_STATUS,
    PERFORMANCE_TABLE_COLUMN_TYPE,
    PERFORMANCE_TABLE_COLUMN_OBJECTIVE,
    PERFORMANCE_TABLE_COLUMN_VISITORS_REACHED,
    PERFORMANCE_TABLE_COLUMN_VIDEO_REELS_PLAYED,
    PERFORMANCE_TABLE_COLUMN_CLICKS,
    PERFORMANCE_TABLE_COLUMN_ACTIVATION_URL,
    PERFORMANCE_TABLE_COLUMN_PUBLISHED_AT,
    PERFORMANCE_TABLE_COLUMN_IMPRESSIONS,
    PERFORMANCE_TABLE_COLUMN_STARTED,
    PERFORMANCE_TABLE_COLUMN_START_RATE,
    PERFORMANCE_TABLE_COLUMN_BUTTON_CLICKS,
    PERFORMANCE_TABLE_COLUMN_BUTTON_ENGAGEMENT,
    PERFORMANCE_TABLE_COLUMN_CONVERSIONS,
    PERFORMANCE_TABLE_COLUMN_TOTAL_WATCH_TIME_SECONDS,
] as const;

export type ColumnId = (typeof columnIds)[number];

export const END_ALIGNED_COLUMNS: string[] = [
    PERFORMANCE_TABLE_COLUMN_PUBLISHED_AT,
    PERFORMANCE_TABLE_COLUMN_IMPRESSIONS,
    PERFORMANCE_TABLE_COLUMN_VISITORS_REACHED,
    PERFORMANCE_TABLE_COLUMN_STARTED,
    PERFORMANCE_TABLE_COLUMN_VIDEO_REELS_PLAYED,
    PERFORMANCE_TABLE_COLUMN_START_RATE,
    PERFORMANCE_TABLE_COLUMN_VISITOR_INTERACTION_RATE,
    PERFORMANCE_TABLE_COLUMN_TOTAL_WATCH_TIME_SECONDS,
    PERFORMANCE_TABLE_COLUMN_BUTTON_CLICKS,
    PERFORMANCE_TABLE_COLUMN_BUTTON_ENGAGEMENT,
    PERFORMANCE_TABLE_COLUMN_CONVERSIONS,
];

export type PerformancePageProps = PageProps<{
    flows: FlowData[];
    overallStatistics: OverallStatistics;
    goalsAndConversionsEnabled: boolean;
    reels: Reel[];
    hiddenPerformanceColumns: string[];
    showMetricDefinitions: boolean;
    sort: string;
    direction: 'asc' | 'desc';
    pagination?: {
        current_page: number;
        total: number;
        per_page: number;
        total_pages: number;
    };
}>;

export interface FlowMetrics {
    impressions: number;
    started: number;
    videos_played: number;
    button_clicks: number;
    start_rate: number;
    total_watch_time_seconds: number;
    button_engagement: number;
    visitor_interaction_rate: number;
}

export type OverallStatistics = {
    flow_button_clicks: number;
    flow_impressions: number;
    flow_started: number;
    conversions: number;
    total_watch_time_seconds: number;
    unique_visitors: number;
    videos_played: number;
    visitor_interaction_rate: number;
};

export interface FlowData {
    id: number;
    name: string;
    config: {
        type: 'Inline' | 'Overlay';
        objectives: string[];
        page: string;
        player?: {
            videos?: Array<{ reelId?: string }>;
        };
    };
    status: string;
    archived_at?: string | null;
    unarchived_at?: string | null;
    first_published_at: string;
    has_newer_version: boolean;
    impressions: number;
    started: number;
    videos_played: number;
    button_clicks: number;
    conversions: number;
    start_rate: number;
    total_watch_time_seconds: number;
    button_engagement: number;
    visitors_reached: number;
    visitor_interaction_rate: number;
}
